import { useMemo } from 'react'

import { EgdApiClient } from '../clients/egdApiClient/egdApiClient'
import { UrlUtils } from '../utils/url'

export interface IUseApiArgs {
  host: string
  accessToken: string
}

export const useApi = ({ host, accessToken }: IUseApiArgs) => {
  const urlUtils = useMemo(() => UrlUtils(), [])
  const commonHeaders = useMemo(
    () => ({
      Authorization: accessToken ? `Bearer ${accessToken}` : undefined
    }),
    [accessToken]
  )

  const apiClient = useMemo(() => EgdApiClient({ host, commonHeaders, urlUtils }), [host, commonHeaders, urlUtils])

  return useMemo(() => apiClient, [apiClient])
}
